import { instance } from "libs/api";

import { ApiRoutesFinancialReport } from "../../constants";
import {
  FinancialPeriodParams,
  FinancialSummaryResponse
} from "../financialReport.types";

export const requestFinancialSummary = async (
  params: FinancialPeriodParams
): Promise<FinancialSummaryResponse> => {
  return await instance.get(ApiRoutesFinancialReport.Summary, { params });
};
